import * as React from "react";

class ErrorUtils {
    public static message = {
        REQUEST_LIMIT_EXCEEDED: "Permitted daily request limit exceeded for this model. Contact tech@genesis.io for more information",
        THIRD_PARTY_SUPPLIER_ERROR: "API provided from the supplier is not responding.",
    };

    public static errorCode = {
        THIRD_PARTY_SUPPLIER_ERROR: 452,
    };

    public static messageContent = {
        REQUEST_LIMIT_EXCEEDED: <span>Permitted daily request limit exceeded for this model.
            Please contact <a href="mailTo:tech@genesisai.io">tech@genesisai.io</a> for more information.
        </span>
    }

    public static requestLimitExceeded = (errorResponse: any) => {
        return errorResponse && errorResponse.status === 429;
    };
}

export default ErrorUtils;


// WEBPACK FOOTER //
// ./src/utils/ErrorUtils.tsx